import handleFloat from './handleFloat'

export default function handleOpacity({ oldValue, newValue }) {
    if (isNaN(newValue) == false) {
        const parsed = handleFloat({ oldValue, newValue })
        if (parsed >= 0 && parsed <= 100) {
            return parsed
        }
        return 100
    }
    return oldValue
}